import publisherAPIInstance from "../publisher/publisherApiInstance";
import magnifiAPIInstance from "./apiInstance";

export const userAPIs = {
  forgotPassword: ({ payload }) => magnifiAPIInstance.post(`/fogot_password`, payload, { skipAuthHeader: true }),
  getSSOUrl: ({ payload }) => magnifiAPIInstance.post(`/sso/get_sign_url`, payload, { skipAuthHeader: true }),
  login: ({ payload }) => magnifiAPIInstance.post(`/login`, payload, { skipAuthHeader: true }),
  signup: ({ payload }) => magnifiAPIInstance.post(`/signup`, payload, { skipAuthHeader: true }),
  registerGCPUser: ({ payload }) =>
    magnifiAPIInstance.post(`/management/gcp-marketplace/register`, payload, { skipAuthHeader: true }),
  updateToken: ({ payload }) => magnifiAPIInstance.post(`/update_token`, payload),
  getMyProfile: ({ payload }) => magnifiAPIInstance.get(`/me`, payload),
  getUsers: ({ userId, payload }) => magnifiAPIInstance.post(`/get_invite_user/${userId}`, payload),
  removeIp: ({ payload }) => magnifiAPIInstance.post(`/remove_ip`, payload),
  deleteUserProfile: ({ payload }) => magnifiAPIInstance.post(`/delete/social-media-profile`, payload),
  editUserProfile: ({ payload }) => magnifiAPIInstance.post(`/edit/social-media-profile`, payload),
  createUserProfile: ({ payload }) => magnifiAPIInstance.post(`/create/social-media-profile`, payload),
  addSocialMediaPlatforms: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/social_media.generate_profile_jwt`, payload),
  getBrightCoveToken: ({ payload }) => magnifiAPIInstance.post(`/access_token`, payload),
  resetUserPassword: ({ payload }) => magnifiAPIInstance.put(`/user/reset-password`, payload),
};
